import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTime from 'react-datetime';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import { SR_API_ACTION_ADMIN_UPDATE_TOUR_START_DATE } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';

class SrAdminTourCardSelectStartDate extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    reloadDataTableTour: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  _onStartDateChange = (value) => {
    const { tour, reloadDataTableTour, dispatch } = this.props;
    if (
      value
      && typeof value === 'object'
      && typeof value.isValid === 'function'
      && value.isValid()
      && !momentWithAustinTimezone(tour.startDate).isSame(value)
    ) {
      dispatch(postWithState, {
        action: SR_API_ACTION_ADMIN_UPDATE_TOUR_START_DATE,
        payload: {
          tourId: tour.id,
          startDate: value.toISOString(),
        },
      }).then(reloadDataTableTour);
    }
  }

  render() {
    const { tour } = this.props;

    return (
      <DateTime
        defaultValue={tour.startDate ? momentWithAustinTimezone(tour.startDate) : 'choose date/time'}
        onBlur={this._onStartDateChange}
        isValidDate={(current) => current.isAfter(momentWithAustinTimezone().subtract(1, 'day'))}
      />
    );
  }
}

SrAdminTourCardSelectStartDate.displayName = 'SrAdminTourCardSelectStartDate';

export default SrAdminTourCardSelectStartDate;
